import { DateTime } from 'luxon';
import {PieceRateActivity} from '../models/piece-rate-activity';

export class PieceRateAdjSummary {
    id ? = 0;
    siteId?: string;
    date?: DateTime;
    shiftId?: number;
    pieceRateActivity?: number;

    groupPrimaryPieces?: number;
    groupSecondaryPieces?: number;
    groupAudited?: number;
    groupFailed?: number;

    adjustmentTotal?: number = 0;
    adjustmentTotalByTemps?: number = 0;
    componentUsageTotal?: number = 0;

    constructor(siteId: string, date: DateTime, shiftId: number) {
        this.siteId = siteId;
        this.date = date;
        this.shiftId = shiftId;
    }
}
